import React, { useState } from "react";
import { Link, useParams } from "react-router-dom";
import EfsInvDetails from "./EfsInvDetails/EfsInvDetails";
import EfsInvItems from "./EfsInvDetails/EfsInvItems/EfsInvItems";

let EfsTabs = [
  { label: "Inv Details", value: "inv-details" },
  { label: "Inv Items", value: "inv-items" },
];

const RenderTabs = ({ activeTab, setActiveTab }) => {
  return (
    <div className="btn-group">
      {EfsTabs.map((tab) => (
        <button
          key={tab.value}
          className={`btn  ${
            activeTab === tab.value ? "btn-primary" : "btn-outline-primary"
          }`}
          onClick={() => setActiveTab(tab.value)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

const RenderTabContent = ({ activeTab, invId }) => {
  switch (activeTab) {
    case "inv-details":
      return <EfsInvDetails invId={invId} />;
    case "inv-items":
      return <EfsInvItems invId={invId} />;
    default:
      return null;
  }
};

export default function EfsInvDetailsLayout() {
  // Get invId from param
  const { invId } = useParams();
  /* ******************** All States ************************* */
  const [activeTab, setActiveTab] = useState("inv-details");

  /* ******************** All Functions ************************* */

  /* ******************** All UseEffects ************************* */

  return (
    <div
      className=""
      style={{
        marginLeft: 260,
      }}
    >
      {/* ******************** Tabs ************************* */}
      <div className="d-flex justify-content-between align-items-center bg-white w-100 shadow-sm rounded-3 p-2">
        <RenderTabs activeTab={activeTab} setActiveTab={setActiveTab} />
        <Link to="/manufacturer/efs-invoice" className="btn btn-danger btn-sm">
          Back
        </Link>
      </div>
      {/* ******************** Tab Content ************************* */}
      <div className="mt-1 p-2">
        <RenderTabContent activeTab={activeTab} invId={invId} />
      </div>
    </div>
  );
}
